import React, { useState, useEffect } from "react";
import { Form, Button, Row, Col, Card } from "react-bootstrap";
import {
  getAwardtypeById,
  updateAwardtype,
} from "../../../../services/AwardtypeService";

import { getAwardceremony } from "../../../../services/AwardceremonyService";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";

const EditAwardtype = () => {
  const [awardtype, setAwardtype] = useState({
    label: "",
    amount: "",
    value: "",
    type: "",
    description: "",
    quater: "",
    isSubsequent: false,
    subsequentAmount: "0",
    showSpotBonus: false,
  });
  const { id } = useParams();
  const navigate = useNavigate();
  const [awardceremony, setAwardceremony] = useState([]);
  // Fetch awardtype data when component mounts
  useEffect(() => {
    fetchAwardceremony();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getAwardtypeById(id);
        setAwardtype(data);
      } catch (error) {
        console.error("Error fetching awardtype:", error);
      }
    };
    fetchData();
  }, [id]);

  const fetchAwardceremony = async () => {
    try {
      const data = await getAwardceremony();
      setAwardceremony(data);
    } catch (error) {
      console.error("Error fetching awardceremony:", error);
    }
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    // Send the form data to the server
    try {
      await updateAwardtype(id, {
        label: awardtype.label,
        amount: awardtype.amount,
        value: awardtype.value,
        type: awardtype.type,
        description: awardtype.description,
        quater: awardtype.quater,
        isSubsequent: awardtype.isSubsequent || false,
        subsequentAmount: awardtype.subsequentAmount || "0",
        showSpotBonus: awardtype.showSpotBonus || false,
      });
      // Show success toast notification
      toast.success("Awardtype updated Successfully!", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000, // Closes after 2 seconds
      });
      // Delay navigation to ensure toast is visible
      setTimeout(() => {
        navigate("/settings/awardtypes");
      }, 3000);
    } catch (error) {
      console.error("Error in awardtype update:", error);
      toast.error("Failed to Update Awardtype!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
      });
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    console.log(`Field Name: ${name}, Field Value: ${value}`); // Debugging
    setAwardtype({ ...awardtype, [name]: value });
  };

  const handleTypeChange = (option) => {
    setAwardtype({ ...awardtype, type: option.value });
  };

  const handleQuaterChange = (option) => {
    setAwardtype({ ...awardtype, quater: option.value });
  };

  const handleshowSpotBonusChange = (option) => {
    setAwardtype({ ...awardtype, showSpotBonus: option.value });
  };

  const handleIsSubsequentChange = (event) => {
    setAwardtype({ ...awardtype, isSubsequent: event.target.checked });
  };

  return (
    <>
      <Card>
        <div className="card-body">
          <Row>
            <Col xs={12}>
              <h4>Edit Award Type</h4>
              {awardtype ? (
                <Form onSubmit={handleSubmit}>
                  <Row className="mb-3 mt-3">
                    <Col md={3}>
                      <Form.Group controlId="label">
                        <Form.Label>Label</Form.Label>
                        <Form.Control
                          type="text"
                          name="label"
                          value={awardtype.label || ""}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="value">
                        <Form.Label>Value</Form.Label>
                        <Form.Control
                          type="text"
                          name="value"
                          value={awardtype.value || ""}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="amount">
                        <Form.Label>Amount</Form.Label>
                        <Form.Control
                          type="amount"
                          name="amount"
                          value={awardtype.amount || ""}
                          onChange={handleChange}
                          min="1"
                          placeholder="Amount"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <div controlId="value">
                        <label>Type</label>
                        <Select
                          name="type"
                          options={[
                            { value: "normal", label: "Normal" },
                            { value: "spot", label: "Spot" },
                          ]}
                          value={[
                            { value: "normal", label: "Normal" },
                            { value: "spot", label: "Spot" },
                          ].filter((e) => awardtype.type.includes(e.value))}
                          placeholder="Select Award type..."
                          className={`react-select-container`}
                          classNamePrefix="react-select"
                          onChange={(option) => handleTypeChange(option)}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={3}>
                      <Form.Group controlId="description">
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                          type="text"
                          name="description"
                          className="form-control"
                          placeholder="text"
                          value={awardtype.description || ""}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <div controlId="quater">
                        <label>Quater</label>
                        <Select
                          name="quater"
                          options={awardceremony}
                          value={awardceremony.filter((e) =>
                            awardtype.quater.includes(e.value)
                          )}
                          placeholder="Select Award Ceremony Quater..."
                          className={`react-select-container`}
                          classNamePrefix="react-select"
                          onChange={(option) => handleQuaterChange(option)}
                        />
                      </div>
                    </Col>
                    <Col ms={3}>
                      <div controlId="showSpotBonus">
                        <label>Show Spot Bonus</label>
                        <Select
                          name="showSpotBonus"
                          options={[
                            { value: false, label: "No" },
                            { value: true, label: "Yes" },
                          ]}
                          placeholder="Select Spot Bonus..."
                          className={`react-select-container`}
                          classNamePrefix="react-select"
                          onChange={(option) => {
                            handleshowSpotBonusChange(option);
                          }}
                        />
                      </div>
                    </Col>
                    <Col ms={2}>
                      <Form.Group controlId="isSubsequent">
                        <Form.Check
                          type="checkbox"
                          label="is subsequent"
                          name="isSubsequent"
                          onChange={handleIsSubsequentChange}
                        />
                      </Form.Group>
                    </Col>

                    {awardtype.isSubsequent && (
                      <Col ms={2}>
                        <Form.Group controlId="subsequentAmount">
                          <Form.Label>Subsequent Amount</Form.Label>
                          <Form.Control
                            type="text"
                            name="subsequentAmount"
                            placeholder="Enter amount"
                            defaultValue={"0"}
                            onChange={handleChange}
                          />
                        </Form.Group>
                      </Col>
                    )}
                  </Row>
                  <Row style={{ marginTop: "20px" }}>
                    <div className="d-flex">
                      <Button className="me-2" variant="primary" type="submit">
                        Save Changes
                      </Button>
                      <Button
                        className="btn-danger"
                        variant="warning"
                        href="/settings/awardtypes"
                      >
                        Cancel
                      </Button>
                    </div>
                  </Row>
                </Form>
              ) : (
                ""
              )}
            </Col>
          </Row>
        </div>
      </Card>
      <ToastContainer />
    </>
  );
};

export default EditAwardtype;
